import {combineReducers} from 'redux';
import AuthReducer from "./AuthReducer";
import FileReducer from "./FileReducer";
import AttachmentsReducer from "./AttachmentsReducer";
import ViewerReducer from "./ViewerReducer";
import ClinicReducer from "./ClinicReducer";
import RowReducer from "./RowReducer";
import FileserverReducer from "./FileserverReducer";
import SupportingDocumentsReducer from "./SupportingDocumentsReducer";
export default combineReducers({
  auth:AuthReducer,
  files:FileReducer,
  attachments:AttachmentsReducer,
  viewer:ViewerReducer,
  clinicdata:ClinicReducer,
  rowreducer:RowReducer,
  fileserver:FileserverReducer,
  supportingdocuments:SupportingDocumentsReducer
})
